import { AbstractFault, Fault } from "@app/shared";

@Fault('Modutecture.Shared.DTOsV2.ProgramProjectMismatchFault, Modutecture.Shared')
export class ProgramProjectMismatchFault extends AbstractFault {
    public code: string;
}